const actions = {
  FETCH_TASKS_BEGIN: 'FETCH_TASKS_BEGIN',
  FETCH_TASKS_SUCCESS: 'FETCH_TASKS_SUCCESS',
  FETCH_TASKS_ERR: 'FETCH_TASKS_ERR',

  FETCH_VERBIAGES_BEGIN: 'FETCH_VERBIAGES_BEGIN',
  FETCH_VERBIAGES_SUCCESS: 'FETCH_VERBIAGES_SUCCESS',
  FETCH_VERBIAGES_ERR: 'FETCH_VERBIAGES_ERR',

  COMPLETE_TASK_BEGIN: 'COMPLETE_TASK_BEGIN',
  COMPLETE_TASK_SUCCESS: 'COMPLETE_TASK_SUCCESS',
  COMPLETE_TASK_ERR: 'COMPLETE_TASK_ERR',

  fetchTasksBegin: () => ({ type: actions.FETCH_TASKS_BEGIN }),
  fetchTasksSuccess: () => ({ type: actions.FETCH_TASKS_SUCCESS }),
  fetchTasksErr: (data) => ({ type: actions.FETCH_TASKS_ERR, data }),

  fetchVerbiagesBegin: () => ({ type: actions.FETCH_VERBIAGES_BEGIN }),
  fetchVerbiagesSuccess: () => ({ type: actions.FETCH_VERBIAGES_SUCCESS }),
  fetchVerbiagesErr: (data) => ({ type: actions.FETCH_VERBIAGES_ERR, data }),

  completeTaskBegin: () => ({ type: actions.COMPLETE_TASK_BEGIN }),
  completeTaskSuccess: () => ({ type: actions.COMPLETE_TASK_SUCCESS }),
  completeTaskErr: (data) => ({ type: actions.COMPLETE_TASK_ERR, data }),
};

export default actions;
